import { render, staticRenderFns } from "./jhbReply.vue?vue&type=template&id=ca7fc966&scoped=true&"
import script from "./jhbReply.vue?vue&type=script&lang=js&"
export * from "./jhbReply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7fc966",
  null
  
)

export default component.exports